import React from "react";

export function StateInspectorTitleLabel({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      {children}
    </span>
  );
}
